export enum RouterNames {
  LOGGED_IN_DASHBOARD = 'Dashboard',
  LOGGED_IN_SEARCH = 'Search',
  LOGGED_IN_PROJECT_VIEW = 'Project View',
  LOGGED_IN_PROCUREMENT_VIEW = 'Procurement View',
  LOGGED_IN_BLACKLIST_VIEW = 'Blacklist View',
  LOGGED_IN_USER_SETTINGS = 'User Settings',
  LOGGED_IN_LIST_VIEW = 'List View',
  LOGGED_IN_COMPANY_SEARCH = 'Company Search',
  LOGGED_IN_COMPANY_VIEW = 'Company View',
  LOGGED_IN_ACCESS_EXPIRED = 'Access Expired',
  LOGGED_OUT_CHANGE_PASSWORD = 'Change Password',
  LOGGED_OUT_ACTIVATE = 'Activate',
  INVALID_SESSION = 'Invalid Session',
  LOGGED_OUT_IMPERSONATE_USER = 'Impersonate User',
  PRINT_PROCUREMENT = 'PrintProcurement',
  PRINT_PROJECT = 'PrintProject',
  LOGGED_IN_HELP = 'Help',
  ERROR_NOT_FOUND = '404',
}
